import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PolicyPackBuilderPage } from '@/features/policy-pack/builder-page'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'

// Final-review fix wave / Important 1: the builder is a write-oriented surface
// (Draft N policies). The API write gate (`requirePolicyManage` in
// policy-packs.route.ts) is `requireAccessOrLegacyRole({ permission:
// "policies.manage", legacyRoles: ["owner","admin","team_leader"] })` — no
// client-side capability guard for `policies.manage` exists, so mirror the
// legacyRoles list exactly. Admitting the broader compliance-staff read roles
// here let them open the builder and hit a 403 on Draft — a dead end.
const POLICY_PACK_MANAGE_ROLES = ['owner', 'admin', 'team_leader'] as const

export const Route = createFileRoute('/_authenticated/_organization/compliance/policy-pack/')({
  validateSearch: z.object({
    standard: z.string().optional(), policy: z.string().optional(), single: z.string().optional(),
    tab: z.enum(['describe', 'recommended']).optional(), fromRun: z.string().optional(), fromDraft: z.string().optional(),
  }),
  beforeLoad: async () => { await requireRoles([...POLICY_PACK_MANAGE_ROLES]); await requireActiveSubscription() },
  component: PolicyPackBuilderPage,
})
